import { Typography } from "@mui/material";

import { Close, InactiveModal, ModalContainer, NoteContainer, Notes } from "../../styles";

interface InactiveModalProps {
  onClose: () => void;
}

export const InactivePlaylist = (props: InactiveModalProps) => (
  <ModalContainer>
    <InactiveModal>
      <NoteContainer>
        <Notes>Note</Notes>
        <Close
          onClick={() => {
            props.onClose();
          }}
        >
          X
        </Close>
      </NoteContainer>
      <Typography maxWidth={350} textAlign="center">
        <strong>
          User does not have an active playlist. Call cannot be made to the user at this time!
        </strong>
      </Typography>
    </InactiveModal>
  </ModalContainer>
);
